import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { adaptUserData } from './adapters.js';
import UserInfoOverview from './UserInfoOverview.js';

const UserInfoOverviewContainer = (_param)=>{
    var { user  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "user"
    ]);
    const { getLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            name: getLabel('appointments.component.userInfoOverview.name'),
            child: getLabel('appointments.component.userInfoOverview.child'),
            email: getLabel('appointments.component.userInfoOverview.email'),
            phone: getLabel('appointments.component.userInfoOverview.phone')
        })
    , [
        getLabel
    ]);
    const userData = React.useMemo(()=>adaptUserData(user, labels)
    , [
        user,
        labels
    ]);
    return /*#__PURE__*/ React.createElement(UserInfoOverview, swcHelpers.extends({}, rest, {
        user: userData
    }));
};
var UserInfoOverviewContainer$1 = UserInfoOverviewContainer;

export { UserInfoOverviewContainer$1 as default };
//# sourceMappingURL=UserInfoOverviewContainer.js.map
